import angular from 'angular';
import 'angular-popeye';
import './modules/mainController.js';
import './modules/payments.js';
import './modules/modal.js';
import './modules/pagination.js';



/** WEBPACK FOOTER **
 ** ./js/app.js
 **/